import type { QueryClient } from '@tanstack/react-query';

import { getApiChangelogsGetCollectionQueryKey } from '@r/api/generated/client.ts';

/** Clé de la liste mega-admin (table serveur, `changelogs-table.tsx`). */
export const ADMIN_CHANGELOGS_LIST_QUERY_KEY = ['admin-changelogs-list'] as const;
/** Préfixe du flux public à scroll infini (`changelog-feed.tsx`). */
export const CHANGELOGS_FEED_QUERY_KEY = ['changelogs-feed'] as const;

/**
 * Invalide toutes les vues qui listent des changelogs : la table mega-admin, le flux
 * public (`/changelogs` admin + client + modale de connexion). À appeler après toute
 * création / édition / suppression pour éviter que l'une des vues reste périmée.
 */
export function invalidateChangelogQueries(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: ADMIN_CHANGELOGS_LIST_QUERY_KEY }),
    queryClient.invalidateQueries({ queryKey: getApiChangelogsGetCollectionQueryKey() }),
    queryClient.invalidateQueries({ queryKey: CHANGELOGS_FEED_QUERY_KEY })
  ]);
}
